export default function Logo(): JSX.Element {
  return (
    <div className="top">
      <h1 style={{ height: '40px', margin: '10px', color: '#FFF' }}>BizHost</h1>
    </div>
  );
}
